import React, { FC } from 'react';
import { FlexBox } from "../../../../../../components/FlexBox";
import { Title } from "../../../../components/Topography/Title";
import { homePageTexts } from "../../const";
import { Paragraph } from "../../../../components/Topography/Paragraph";
import image from "../../../../images/editorIcons.png";
import { Section } from "../../../../components/Section";
import { useResizeContext } from "../../../../providers/ResizeProvider/ResizeProvider";
import { Arrow } from "../../../../icons/Arrow";

export const EditAndAnnotateScreenshotSection: FC = () => {
    const { isMobile } = useResizeContext();

    return (
        <Section style={{marginTop: 0}}>
            <FlexBox
                justify='space-between'
                align={isMobile ? 'middle' : 'top'}
                style={{ gap: isMobile ? '0' : '80px'}}
                column={isMobile}
            >
                <FlexBox column style={{ padding: isMobile ? 0 : '40px', gap: '40px' }}>
                    <FlexBox column gap='medium'>
                        <Title level={3} size={isMobile ? 'tiny' : 'small'} weight='regular' style={{ textTransform: 'uppercase' }} secondary>
                            {homePageTexts.editAndAnnotateScreenshot.h3}
                        </Title>
                        <Title level={2} size={isMobile ? 'normal' : 'big'} weight='bold' style={{ maxWidth: '552px', position: 'relative' }} >
                            {homePageTexts.editAndAnnotateScreenshot.h2}
                            <Arrow style={{ position: 'absolute', bottom: '-40px', right: 0, transform: 'rotate(90deg)' }}/>
                        </Title>
                    </FlexBox>
                    <Paragraph  size='small' weight='regular' style={{ borderRadius: "16px", border: '4px solid #FC0404' }}>
                        <span style={{ padding: '16px', display: 'block' }}>
                            {homePageTexts.editAndAnnotateScreenshot.p}
                        </span>
                    </Paragraph>
                </FlexBox>
                <FlexBox justify='center' align='middle' style={{ alignSelf: 'center', maxWidth: '344px', flexShrink: 0 }}>
                    <img src={image} alt="" style={{ width: '100%' }}/>
                </FlexBox>
            </FlexBox>
        </Section>
    );
}